module.exports = __webpack_public_path__ + "img/GKW_I.3ba108bc.svg";